"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedToFetch = exports.isomorphicUrl = exports.enhancedFetch = exports.getResponseErrors = exports.getFileKeys = exports.isFormData = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const helpers_1 = require("./helpers");
const Journey_1 = require("./Journey");
const EnhancedFetchInit_1 = require("./EnhancedFetchInit");
const EnhancedFetchError_1 = require("./EnhancedFetchError");
// because FormData is not defined in Node.
function isFormData(data) {
    if (helpers_1.isServer()) {
        return false;
    }
    return data instanceof FormData;
}
exports.isFormData = isFormData;
function getFileKeys(body) {
    if (helpers_1.isServer()) {
        return [];
    }
    return Object.keys(body).filter((key) => {
        const value = body[key];
        if (Array.isArray(value)) {
            return value.find((r) => r instanceof File || r instanceof FileList);
        }
        return value instanceof File || value instanceof FileList;
    });
}
exports.getFileKeys = getFileKeys;
function getResponseErrors(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const clonedResponse = yield response.clone();
        if (clonedResponse.status === 404) {
            return {
                main: `(404) URL "${response.url}" response is not found.`,
            };
        }
        let reason = 'Server error';
        try {
            const responseText = yield clonedResponse.text();
            const responseJson = JSON.parse(responseText);
            if (responseJson.message) {
                reason = responseJson.message;
                if (!!responseJson.errors && typeof responseJson.errors === 'object') {
                    return responseJson.errors;
                }
                // 500 errors on local returns this.
                if (responseJson.line && responseJson.file) {
                    reason = `${responseJson.file} - line ${responseJson.line}: ${responseJson.message}`;
                }
                if (reason === 'Server error' && clonedResponse.status === 413) {
                    reason = 'File too large to upload.';
                }
                return {
                    main: `(${clonedResponse.status}) URL "${clonedResponse.url}": ${reason}`,
                };
            }
        }
        catch (_a) {
            // do nothing
        }
        return {
            main: `(${clonedResponse.status}) URL "${clonedResponse.url}" ${reason}`,
        };
    });
}
exports.getResponseErrors = getResponseErrors;
function enhancedFetch(url, init = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const enhancedFetchInit = new EnhancedFetchInit_1.EnhancedFetchInit(url, init);
        let initAttributes = Object.assign(Object.assign({}, enhancedFetchInit.sanitizedAttributes()), { headers: yield enhancedFetchInit.sanitizeHeaders(enhancedFetchInit.attributes.headers) });
        if (Journey_1.Journey.config.beforeRequest) {
            initAttributes = Journey_1.Journey.config.beforeRequest(initAttributes);
        }
        const { url: sanitizedUrl, responseType, formatResponse, onResponse } = initAttributes;
        const requestUrl = isomorphicUrl(sanitizedUrl);
        // run our request using native fetch from javascript.
        const response = yield cross_fetch_1.default(requestUrl, initAttributes);
        if (!response.ok) {
            const errorMessage = yield EnhancedFetchError_1.createErrorMessageOfResponse(response);
            throw (new EnhancedFetchError_1.EnhancedFetchError(errorMessage, response.clone()));
        }
        let responseBody;
        try {
            responseBody = yield (responseType === 'text' ? response.text() : response.json());
        }
        catch (_a) {
            // DELETE methods may not return a body and that's okay.
        }
        const responseBodyExisted = !!responseBody;
        responseBody = formatResponse ? formatResponse(responseBody) : Journey_1.Journey.formatResponse(responseBody);
        if (responseBodyExisted && !responseBody) {
            console.error(`${url} appears to have had its response body formatted
        incorrectly as the response is now undefined after formatResponse(), please check your JourneyUI config "onResponse".`);
        }
        // this must be after formatResponse
        if (onResponse && responseBody) {
            onResponse(Array.isArray(responseBody) ? [...responseBody] : Object.assign({}, responseBody));
        }
        return responseBody;
    });
}
exports.enhancedFetch = enhancedFetch;
/*
  In order for us to have cookies work properly for us across multiple domains.
  We have to use next.js as a proxy server that will run our request.
  So our path is really just a relative path (localhost/api/maps/directly/to/laravel) but the fetch on server needs
  an absolute url.
 */
function isomorphicUrl(path) {
    // if absolute path, dont bother just return what it is.
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    if (helpers_1.isServer()) {
        if (!Journey_1.Journey.config.serversideBaseDomain) {
            throw new Error('Cant make serverside request as there is no "serversideBaseDomain" in the journey ui config.');
        }
        if (path.startsWith('/')) {
            path = path.slice(1, path.length);
        }
        return `${Journey_1.Journey.config.serversideBaseDomain}/${path}`;
    }
    return `${path}`;
}
exports.isomorphicUrl = isomorphicUrl;
/* props provided from useFetch or usePaginate
* main benefit is to do a string check on the url and make sure "undefined" doesnt exist
* which will cut out a lot of cognitive overhead for the end user always checking to make sure a slug or something exists
* I dont see a scenario where you would send a request with "undefined" anyways and/or its worth the risk!
 */
function isAllowedToFetch({ isAllowed, url, urlContainsUndefined }) {
    if (!urlContainsUndefined && url.includes('undefined')) {
        /* if (process.env.NODE_ENV === 'development') {
          console.log(`Request "${url}" was ignored due to having "undefined" in its string.`)
        } */
        return false;
    }
    // true if not defined.
    return isAllowed !== null && isAllowed !== void 0 ? isAllowed : true;
}
exports.isAllowedToFetch = isAllowedToFetch;
